// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".glasseson-global *[data-v-3a1b95c2]{box-sizing:border-box;margin:0}.glasseson-global[data-v-3a1b95c2] :not(input){-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.go_btn[data-v-3a1b95c2]{color:#fff;font-weight:700;border-radius:15px;padding:10px 20px;margin:0 auto;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
